export enum TournamentJoinType {
    ALL = 'all',
    PAYERS = 'payers',
    NON_PAYING = 'nonpaying',
}